import "./SideNaveContainer.css";
import { useCallback, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { auth } from "../../configs/firebase.config";
import { getUserProfile } from "../../helpers/profile_helper";

const SideNaveContainer = ({ className = "", closenav }) => {
  const showFeeAccountLoads = process.env.REACT_APP_SHOW_FEE_ACCOUNT_LOADS === "true";
  const showTransactionsPage =
    process.env.REACT_APP_SHOW_TRANSACTIONS_PAGE === "true";
  const showWalletLoads = process.env.REACT_APP_SHOW_WALLET_LOADS === "true";
  const showStatements = process.env.REACT_APP_SHOW_STATEMENTS === "true";
  const showPayoutStatus = process.env.REACT_APP_SHOW_PAYOUT_STATUS === "true";
  const showCollectWithdraw =
    process.env.REACT_APP_SHOW_COLLECT_WITHDRAW === "true";
  const showPayoutLoads = process.env.REACT_APP_SHOW_PAYOUT_LOADS === "true";
  const showFundSubAccount =
    process.env.REACT_APP_SHOW_FUND_SUB_ACCOUNT === "true";
  const showCollectStatusWithCollectRef =
    process.env.REACT_APP_SHOW_COLLECT_STATUS_WITH_COLLECT_REF === "true";
  const showCollectStatusWithUTR =
    process.env.REACT_APP_SHOW_COLLECT_STATUS_WITH_UTR === "true";
  const showCollectStatusWithCRN =
    process.env.REACT_APP_SHOW_COLLECT_STATUS_WITH_CRN === "true";
  const location = useLocation();
  const isActive = (path) => location.pathname === path; //function to find the current active file
  const navigate = useNavigate();
  const [userProfile, setUserProfile] = useState("")
  const [adminPermissions, setAdminPermissions] = useState("")
  let hidden_btn = [""]; //list of hidden buttons Classname
  const ishidden = (name) => hidden_btn.includes(name); //function to hide the button

  let disable_btn = [""]; //list of disabled buttons Classname

  const onStatementsButtonsContainerClick = useCallback(() => {
    if (!disable_btn.includes("statements-buttons2")) {
      navigate("/content/stmts");
      closenav();
    }
  }, [navigate]);

  const onFeeAccountLoadsButtonsContainerClick = useCallback(() => {
    if (!disable_btn.includes("walletloads-buttons2")) {
      navigate("/content/feeAccountLoads");
      closenav();
    }
  }, [navigate]);


  const onWalletLoadsButtonsContainerClick = useCallback(() => {
    if (!disable_btn.includes("walletloads-buttons2")) {
      navigate("/content/walletloads");
      closenav();
    }
  }, [navigate]);


  const onWithdrawButtonsContainerClick = useCallback(() => {
    if (!disable_btn.includes("payout-buttons2")) {
      navigate("/content/withdraw");
      closenav();
    }
  }, [navigate]);
  const onLoadPayoutMasterButtonsContainerClick = useCallback(() => {
    if (!disable_btn.includes("payout-buttons2")) {
      navigate("/content/load_payout_master");
      closenav();
    }
  }, [navigate]);
  const onLoadFundMerchantButtonsContainerClick = useCallback(() => {
    if (!disable_btn.includes("payout-buttons2")) {
      navigate("/content/fund_merchant_account");
      closenav();
    }
  }, [navigate]);
  const onpayoutButtonsContainerClick = useCallback(() => {
    if (!disable_btn.includes("payout-buttons2")) {
      navigate("/content/payout");
      closenav();
    }
  }, [navigate]);
  const onCollectStatusButtonsContainerClick = useCallback(() => {
    if (!disable_btn.includes("payout-buttons2")) {
      navigate("/content/collectstatus");
      closenav();
    }
  }, [navigate]);

  const onCheckStatusByUTRContaninerClick = useCallback(() => {
    if (!disable_btn.includes("statement-btn")) {
      navigate("/content/check_status_with_utr");
    }
  }, [navigate]);
  const onCheckStatusByCRNContaninerClick = useCallback(() => {
    if (!disable_btn.includes("statement-btn")) {
      navigate("/content/check_status_with_crn");
    }
  }, [navigate]);
  const onTransactionsButtonsContainerClick = useCallback(() => {
    if (!disable_btn.includes("transactions-buttons2")) {
      navigate("/content/txn");
      closenav();
    }
  }, [navigate]);
  const onAdminButtonsContainerClick = useCallback(() => {
    // if (!disable_btn.includes("transactions-buttons2")) {
    if (true) {
      navigate("/content/admin");
      closenav();
    }
  }, [navigate]);

  const onLoadsButtonsContainerClick = useCallback(() => {
    if (!disable_btn.includes("loads-buttons2")) {
      navigate("/content/load");
      closenav();
    }
  }, [navigate]);
  const handleLogout = useCallback(async () => {
    await auth.signOut();
  }, [navigate]);

  useEffect(() => {
    const fetchData = async () => {

      try {
        var user_profile = await getUserProfile();
        setUserProfile(user_profile);

        var admin_permissions = user_profile.admin_permissions;
        setAdminPermissions(admin_permissions)
        console.log("%o", user_profile)
      } catch (error) {
        localStorage.removeItem("user_profile");
        console.log("%o", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="contain-sidenav">
      <div className={`sidenavecontainer2 , ${className}`}>
        <div className="logo2">
          <img
            className="eazypayouts-2-1-icon2"
            loading="lazy"
            alt=""
            src="/escrow-stack.svg"
          />
          {/* <img className="group-icon2" loading="lazy" alt="" src="/group.svg" /> */}
        </div>
        <div className="sidebar-content1">
          <div className="actions">
            {adminPermissions.includes('VIEW_ONLY') && (
              <div
                id="transaction-btn"
                className={`transactions-buttons2 ${ishidden("transactions-buttons2") ? "hidden-div" : ""
                  } ${disable_btn.includes("transactions-buttons2")
                    ? "disabled"
                    : ""
                  }`}
                onClick={onAdminButtonsContainerClick}
                style={{
                  backgroundColor: isActive("/content/admin") ? "#2447a9" : "",
                  color: isActive("/content/admin") ? "white" : "",
                }}
              >
                <img
                  className="arrow-down-up-icon1"
                  loading="lazy"
                  alt=""
                  src={
                    isActive("/content/txn")
                      ? "/adminIcon.svg"
                      : "/adminIcon.svg"
                  }
                />
                <div className="transactions1">Admin</div>
              </div>
            )}
            {showTransactionsPage && (
              <div
                id="transaction-btn"
                className={`transactions-buttons2 ${ishidden("transactions-buttons2") ? "hidden-div" : ""
                  } ${disable_btn.includes("transactions-buttons2")
                    ? "disabled"
                    : ""
                  }`}
                onClick={onTransactionsButtonsContainerClick}
                style={{
                  backgroundColor: isActive("/content/txn") ? "#2447a9" : "",
                  color: isActive("/content/txn") ? "white" : "",
                }}
              >
                <img
                  className="arrow-down-up-icon1"
                  loading="lazy"
                  alt=""
                  src={
                    isActive("/content/txn")
                      ? "/arrowdownup_white.svg"
                      : "/arrowdownup.svg"
                  }
                />
                <div className="transactions1">Transactions</div>
              </div>
            )}
            {/* <div
              id="load-btn"
              className={`loads-buttons2 ${ishidden("loads-buttons2") ? "hidden-div" : ""} ${disable_btn.includes("loads-buttons2") ? "disabled" : ""}`}
              onClick={onLoadsButtonsContainerClick}
              style={{
                backgroundColor: isActive('/content/load') ? '#2447a9;' : "",
                color: isActive('/content/load') ? 'white' : ""
              }}>
              <img
                className="loads-buttons-item"
                loading="lazy"
                alt=""
                src={isActive('/content/load') ? "/boxarrowindown_white.svg" : "/boxarrowindown.svg"}
              />
              <div className="loads1">Loads</div>
            </div> */}
            {showFeeAccountLoads && (
              <div
                id="wallet-btn"
                className={`statements-buttons2 ${ishidden("statements-buttons2") ? "hidden-div" : ""
                  } ${disable_btn.includes("statements-buttons2") ? "disabled" : ""
                  }`}
                onClick={onFeeAccountLoadsButtonsContainerClick}
                style={{
                  backgroundColor: isActive("/content/feeAccountLoads") ? "#2447a9" : "",
                  color: isActive("/content/feeAccountLoads") ? "white" : "",
                }}
              >
                <img
                  className="statements-buttons-item"
                  loading="lazy"
                  alt=""
                  src={
                    isActive("/content/stmts")
                      ? "/group-2352_white.svg"
                      : "/group-2352.svg"
                  }
                />
                <div className="statements1">Fee A/c Loads </div>
              </div>
            )}
            {showWalletLoads && (
              <div
                id="wallet-btn"
                className={`statements-buttons2 ${ishidden("statements-buttons2") ? "hidden-div" : ""
                  } ${disable_btn.includes("statements-buttons2") ? "disabled" : ""
                  }`}
                onClick={onWalletLoadsButtonsContainerClick}
                style={{
                  backgroundColor: isActive("/content/walletloads") ? "#2447a9" : "",
                  color: isActive("/content/walletloads") ? "white" : "",
                }}
              >
                <img
                  className="statements-buttons-item"
                  loading="lazy"
                  alt=""
                  src={
                    isActive("/content/stmts")
                      ? "/group-2352_white.svg"
                      : "/group-2352.svg"
                  }
                />
                <div className="statements1">Wallet Loads </div>
              </div>
            )}
            {showStatements && (
              <div
                id="statement-btn"
                className={`statements-buttons2 ${ishidden("statements-buttons2") ? "hidden-div" : ""
                  } ${disable_btn.includes("statements-buttons2") ? "disabled" : ""
                  }`}
                onClick={onStatementsButtonsContainerClick}
                style={{
                  backgroundColor: isActive("/content/stmts") ? "#2447a9" : "",
                  color: isActive("/content/stmts") ? "white" : "",
                }}
              >
                <img
                  className="statements-buttons-item"
                  loading="lazy"
                  alt=""
                  src={
                    isActive("/content/stmts")
                      ? "/group-2352_white.svg"
                      : "/group-2352.svg"
                  }
                />
                <div className="statements1">Statements </div>
              </div>
            )}
            {showPayoutStatus && (
              <div
                id="statement-btn"
                className={`transactions-buttons2 ${ishidden("transactions-buttons2") ? "hidden-div" : ""
                  } ${disable_btn.includes("statements-buttons2") ? "disabled" : ""
                  }`}
                onClick={onpayoutButtonsContainerClick}
                style={{
                  backgroundColor: isActive("/content/payout") ? "#2447a9" : "",
                  color: isActive("/content/payout") ? "white" : "",
                }}
              >
                <img
                  className="statements-buttons-item"
                  loading="lazy"
                  alt=""
                  src={
                    isActive("/content/payout")
                      ? "/atm_active.svg"
                      : "/atm1.svg"
                  }
                />
                <div className="payoutStatus1">Payout status</div>
              </div>
            )}
            {showCollectWithdraw && (
              <div
                id="statement-btn"
                className={`transactions-buttons2 ${ishidden("transactions-buttons2") ? "hidden-div" : ""
                  } ${disable_btn.includes("statements-buttons2") ? "disabled" : ""
                  }`}
                onClick={onWithdrawButtonsContainerClick}
                style={{
                  backgroundColor: isActive("/content/withdraw")
                    ? "#2447a9"
                    : "",
                  color: isActive("/content/wotjdraw") ? "white" : "",
                }}
              >
                <img
                  className="statements-buttons-item"
                  loading="lazy"
                  alt=""
                  src={
                    isActive("/content/withdraw")
                      ? "/atm_active.svg"
                      : "/atm1.svg"
                  }
                />
                <div className="payoutStatus1">Collect Withdraw</div>
              </div>
            )}
            {showPayoutLoads && (
              <div
                id="statement-btn"
                className={`transactions-buttons2 ${ishidden("transactions-buttons2") ? "hidden-div" : ""
                  } ${disable_btn.includes("statements-buttons2") ? "disabled" : ""
                  }`}
                onClick={onLoadPayoutMasterButtonsContainerClick}
                style={{
                  backgroundColor: isActive("/content/load_payout_master")
                    ? "#2447a9"
                    : "",
                  color: isActive("/content/wotjdraw") ? "white" : "",
                }}
              >
                <img
                  className="statements-buttons-item"
                  loading="lazy"
                  alt=""
                  src={
                    isActive("/content/load_payout_master")
                      ? "/atm_active.svg"
                      : "/atm1.svg"
                  }
                />
                <div className="payoutStatus1">Payout Loads</div>
              </div>
            )}
            {showFundSubAccount && (
              <div
                id="statement-btn"
                className={`transactions-buttons2 ${ishidden("transactions-buttons2") ? "hidden-div" : ""
                  } ${disable_btn.includes("statements-buttons2") ? "disabled" : ""
                  }`}
                onClick={onLoadFundMerchantButtonsContainerClick}
                style={{
                  backgroundColor: isActive("/content/fund_merchant_account")
                    ? "#2447a9"
                    : "",
                  color: isActive("/content/fund_merchant_account")
                    ? "white"
                    : "",
                }}
              >
                <img
                  className="statements-buttons-item"
                  loading="lazy"
                  alt=""
                  src={
                    isActive("/content/fund_merchant_account")
                      ? "/atm_active.svg"
                      : "/atm1.svg"
                  }
                />
                <div className="payoutStatus1">Fund Sub Account</div>
              </div>
            )}
            {showCollectStatusWithCollectRef && (
              <div
                id="statement-btn"
                className={`transactions-buttons2 ${ishidden("transactions-buttons2") ? "hidden-div" : ""
                  } ${disable_btn.includes("statements-buttons2") ? "disabled" : ""
                  }`}
                onClick={onCollectStatusButtonsContainerClick}
                style={{
                  backgroundColor: isActive("/content/collectstatus")
                    ? "#2447a9"
                    : "",
                  color: isActive("/content/collectstatus") ? "white" : "",
                }}
              >
                <img
                  className="statements-buttons-item"
                  loading="lazy"
                  alt=""
                  src={
                    isActive("/content/collectstatus")
                      ? "/atm_active.svg"
                      : "/atm1.svg"
                  }
                />
                <div className="payoutStatus1">Collect status</div>
              </div>
            )}
            {showCollectStatusWithUTR && (
              <div
                id="statement-btn"
                className={`transactions-buttons2 ${ishidden("transactions-buttons2") ? "hidden-div" : ""
                  } ${disable_btn.includes("statements-buttons2") ? "disabled" : ""
                  }`}
                onClick={onCheckStatusByUTRContaninerClick}
                style={{
                  backgroundColor: isActive("/content/check_status_with_utr")
                    ? "#2447a9"
                    : "",
                  color: isActive("/content/check_status_with_utr")
                    ? "white"
                    : "",
                }}
              >
                <img
                  className="statements-buttons-item"
                  loading="lazy"
                  alt=""
                  src={
                    isActive("/content/check_status_with_utr")
                      ? "/atm_active.svg"
                      : "/atm1.svg"
                  }
                />
                <div className="UTR Status">With UTR</div>
              </div>
            )}
            {showCollectStatusWithCRN && (
              <div
                id="statement-btn"
                className={`transactions-buttons2 ${ishidden("transactions-buttons2") ? "hidden-div" : ""
                  } ${disable_btn.includes("statements-buttons2") ? "disabled" : ""
                  }`}
                onClick={onCheckStatusByCRNContaninerClick}
                style={{
                  backgroundColor: isActive("/content/check_status_with_crn")
                    ? "#2447a9"
                    : "",
                  color: isActive("/content/check_status_with_crn")
                    ? "white"
                    : "",
                }}
              >
                <img
                  className="statements-buttons-item"
                  loading="lazy"
                  alt=""
                  src={
                    isActive("/content/check_status_with_utr")
                      ? "/atm_active.svg"
                      : "/atm1.svg"
                  }
                />
                <div className="UTR Status">With CRN</div>
              </div>
            )}
          </div>

          <div className="logout">
            <div className="logout-buttons2" onClick={handleLogout}>
              <img
                className="box-arrow-right-icon2"
                loading="lazy"
                alt=""
                src="/boxarrowright.svg"
              />
              <div className="logout2">Logout</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SideNaveContainer.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
};

export default SideNaveContainer;
